import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box, useTokens } from "@gemini/core";
import { Button, Divider, FeedbackMessage } from "@gemini/ui";
import { useBackToSearch, useErrorTrackingView } from "@/hooks";
import { HttpStatus } from "@/constants";
import { SimilarListings } from "@/components/SimilarListings";
const getFeedbackTexts = (status) => {
    switch (status) {
        case HttpStatus.UNPUBLISHED:
            return {
                title: "errorpage.unpublished.feedback.title",
                message: "errorpage.unpublished.feedback.message",
            };
        case HttpStatus.DELETED:
            return {
                title: "errorpage.deleted.feedback.title",
                message: "errorpage.deleted.feedback.message",
            };
        case HttpStatus.BROKEN_LINK:
            return {
                title: "errorpage.broken_link.feedback.title",
                message: "errorpage.broken_link.feedback.message",
            };
        case HttpStatus.TECHNICAL_ERROR:
            return {
                title: "errorpage.technical_error.feedback.title",
                message: "errorpage.technical_error.feedback.message",
            };
        default:
            return {
                title: "errorpage.technical_error.feedback.title",
                message: "errorpage.technical_error.feedback.message",
            };
    }
};
const getBtnText = (status) => {
    return status === HttpStatus.UNPUBLISHED
        ? "errorpage.unpublished.cta.label"
        : "errorpage.deleted.cta.label";
};
export const ErrorPage = ({ code, status }) => {
    const tokens = useTokens();
    const { t } = useI18n();
    const headerHeight = tokens["sizing.64"]; // see https://github.com/axel-springer-kugawana/aviv_whitelabel_header_footer/blob/main/white-label/src/components/header/header.tsx
    const btnText = getBtnText(status);
    const feedbackTexts = getFeedbackTexts(status);
    const { handleBackToSearch } = useBackToSearch();
    useErrorTrackingView(code);
    return (_jsx(Box, { minHeight: `calc(100vh - ${headerHeight})`, children: _jsxs(Box, { as: "main", position: "relative", display: "grid", gridTemplateColumns: {
                "breakpoint.base": "repeat(4, [col-start] 1fr)",
                "breakpoint.lg": "repeat(12, [col-start] 1fr)",
                "breakpoint.xl": "repeat(12, [col-start] 1fr)",
            }, gap: {
                "breakpoint.base": "spacing.16",
                "breakpoint.lg": "spacing.24",
            }, maxWidth: {
                "breakpoint.base": "1024px",
                "breakpoint.xl": "1280px",
                "breakpoint.xxl": "1536px",
                "breakpoint.xxxl": "1920px",
            }, paddingHorizontal: {
                "breakpoint.base": "0",
                "breakpoint.lg": "spacing.32",
                "breakpoint.xl": "spacing.80",
            }, marginHorizontal: {
                "breakpoint.lg": "auto",
            }, paddingTop: "spacing.48", marginBottom: "spacing.48", width: "100%", children: [_jsxs(Box, { as: "section", position: "relative", paddingHorizontal: "spacing.16", paddingVertical: "spacing.12", gridColumn: {
                        "breakpoint.base": "col-start / span 4",
                        "breakpoint.md": "col-start / span 4",
                        "breakpoint.lg": "col-start / span 12",
                        "breakpoint.sm": "col-start / span 8",
                        "breakpoint.xl": "col-start 1 / span 12",
                        "breakpoint.xxl": "col-start 2 / span 10",
                        "breakpoint.xxxl": "col-start 2 / span 10",
                    }, children: [_jsx(FeedbackMessage, { variant: "warning", title: t(feedbackTexts.title), children: t(feedbackTexts.message) }), _jsx(Divider, { "aria-hidden": "true", marginVertical: "spacing.40" })] }), _jsx(SimilarListings, {}), _jsx(Box, { as: "section", position: "relative", gridColumn: {
                        "breakpoint.base": "col-start / span 4",
                        "breakpoint.md": "col-start / span 4",
                        "breakpoint.lg": "col-start / span 12",
                        "breakpoint.sm": "col-start / span 8",
                        "breakpoint.xl": "col-start 1 / span 12",
                        "breakpoint.xxl": "col-start 2 / span 10",
                    }, display: "flex", justifyContent: "center", paddingHorizontal: "spacing.16", paddingVertical: "spacing.12", children: _jsx(Button, { isFullWidth: { "breakpoint.base": true, "breakpoint.sm": false }, onPress: handleBackToSearch, marginTop: "spacing.40", children: t(btnText) }) })] }) }));
};
